(ns frontend.view.nev.zap-vault.tab-documents
  (:require [common.localization :as loc]
            [frontend.view.nev.zap-vault.event :as event]
            [frontend.view.nev.zap-vault.sub :as sub]
            [potpuri.core :as potpuri]
            [re-frame.core :as rf]
            [reagent.core :as r]
            [ui.components.alert.view :as alert]
            [ui.components.button.view :as button]
            [ui.components.date-picker.view :as date-picker]
            [ui.components.layout.footer :as footer]
            [ui.components.modal.view :as modal]
            [ui.components.radix-ui.dropdown-menu.view :as dropdown-menu]
            [ui.components.radix-ui.tooltip.view :as tooltip]
            [ui.components.rich-text.tiptap :as tiptap]
            [ui.components.sortable-list.view :as sortable-list]
            [ui.components.text.view :as text]
            [ui.components.toggle.view :as toggle]
            [ui.editors.data-input :as data-input]
            [ui.editors.file.event :as upload-event]
            [ui.editors.file.upload :as upload]
            [ui.editors.labelled-input.view :as labelled-input]))

(defn delete-confirmation-modal
  []
  (let [file-to-delete @(rf/subscribe [::sub/file-to-delete])]
    [modal/view
     {:visible? (boolean file-to-delete)}
     (loc/tr :remove-vault-document? [(:attachment/filename file-to-delete)])
     [:div
      {:class "flex-auto flex flex-col gap-4"}

      [alert/danger
       {}
       (loc/tr :this-action-cannot-be-undone)]

      [footer/footer
       [footer/left-align]
       [footer/right-align
        [button/secondary-hollow
         {:on-click (fn [_]
                      (rf/dispatch [::event/cancel-file-removal]))}
         (loc/tr :exit)]
        [button/primary-solid
         {:on-click (fn [_]
                      (rf/dispatch [::event/delete-file! file-to-delete]))}
         (loc/tr :continue)]]]]]))

(defn edit-modal
  []
  (let [file-to-edit @(rf/subscribe [::sub/file-to-edit])
        vault @(rf/subscribe [::sub/vault])
        changes @(rf/subscribe [::sub/document-changes])
        updated-attachment (potpuri/deep-merge (or file-to-edit {})
                                               (or changes {}))]
    [modal/view
     {:visible? (boolean file-to-edit)}
     (loc/tr :edit-vault-document [(:attachment/filename file-to-edit)])
     [:div
      {:class "flex-auto flex flex-col gap-4"}

      [:div
       {:class "flex flex-col gap-2"}
       [:div
        {:class "flex flex-row gap-2"}
        [labelled-input/view
         {:label           (loc/tr :vault-document-binary)
          :container-class "flex-auto"
          :value           (:attachment/filename updated-attachment)
          :data-type       :data.type/text-simple
          :on-change       (fn [v]
                             (rf/dispatch [::event/edit-document-attribute :attachment/filename v]))}]
        [:div
         {:class "flex flex-col justify-items-end align-self-end cursor-pointer"}
         [data-input/view
          {:data-type   :data.type/file
           :editor-type :editor.type/file-simple
           :trigger     [:span
                         {:class "cursor-pointer text-primary-base"}
                         (loc/tr :replace)]
           :on-change   (fn [{:keys [files]}]
                          (let [upload-state* (r/atom {})]
                            (doseq [file (take 1 files)]
                              (upload-event/start-upload! {:state*     upload-state*
                                                           :target-id  (:db/id vault)
                                                           :replace-id (:db/id file-to-edit)
                                                           :data       {}
                                                           :error!     (fn [resp]
                                                                         (js/console.log "Failed to upload file : " resp))
                                                           :success!   (fn [{:keys []}]
                                                                         (rf/dispatch [::event/edit-document-attribute :attachment/filename (.-name file)]))}
                                                          file))))}]]]

       [labelled-input/view
        {:label     (loc/tr :attachment/title)
         :data-type :data.type/text-simple
         :value     (:attachment/title updated-attachment)
         :on-change (fn [v]
                      (rf/dispatch [::event/edit-document-attribute :attachment/title v]))}]
       [labelled-input/view
        {:label     (loc/tr :attachment/description)
         :data-type :data.type/text-richtext
         :value     (:attachment/description updated-attachment)
         :on-change (fn [v]
                      (rf/dispatch [::event/edit-document-attribute :attachment/description v]))}]]

      [footer/footer
       [footer/left-align]
       [footer/right-align
        [button/secondary-hollow
         {:on-click (fn [_]
                      (rf/dispatch [::event/cancel-file-edit]))}
         (if (seq changes)
           (loc/tr :cancel)
           (loc/tr :close))]
        [button/primary-solid
         {:disabled? (empty? changes)
          :on-click  (fn [_]
                       (rf/dispatch [::event/edit-file! file-to-edit]))}
         (loc/tr :save)]]]]]))

(defn file-item
  [idx {:keys [attachment/filename attachment/description attachment/title attachment/uploaded-on] :as attachment}]
  [:div
   {:class "flex flex-row gap-2 align-baseline group bg-base-light border border-solid border-base-light-border-paler p-4 align-items-center"}
   [:i
    {:class "flex-0 fas fa-file text-3xl text-complement-light-text-paler"}]
   [:div
    {:class    "flex-1 flex flex-col gap-1 cursor-pointer group"
     :on-click (fn [_]
                 (rf/dispatch [::event/open-file (:db/id attachment)]))}
    [text/label
     {:class "cursor-pointer group-hover:underline"}
     (or title "-")]
    [text/info-text-xs
     {:class "cursor-pointer"}
     filename]]
   [:div
    {:class "flex flex-row gap-2 justify-content-end"}
    (when description
      [tooltip/view
       [:i.fal.fa-info-circle]
       [tiptap/viewer {:value description}]])
    [date-picker/format-value
     (or uploaded-on 0)]
    [dropdown-menu/view
     {:props {:align :end
              :side  :bottom}
      :trigger-as-child
      [:i {:class "text-bold fal fa-ellipsis-v px-2"}]
      :items (concat
               (when-not (zero? idx)
                 [{:label    [:div
                              {:class "flex-1 flex flex-row"}
                              [:div
                               {:class " flex flex-row"}
                               (loc/tr :set-as-primary)]
                              [:div
                               {:class "flex-auto flex flex-row align-items-center justify-content-end"}
                               [toggle/toggle
                                {:checked?  false
                                 :on-change identity}]]]
                   :on-click (fn [_]
                               (rf/dispatch [::event/set-primary-file attachment]))}])
               [{:label    (loc/tr :edit)
                 :on-click (fn [_]
                             (rf/dispatch [::event/start-edit-file attachment]))}
                {:label    (loc/tr :remove)
                 :on-click (fn [_]
                             (rf/dispatch [::event/remove-file attachment]))}])}]]])

(defn upload-and-progress
  []
  (let [state* (r/atom {})]
    (fn []
      (let [vault-id @(rf/subscribe [::sub/vault-id])
            files @(rf/subscribe [::sub/documents])]
        [:<>
         [data-input/view
          {:data-type         :data.type/file
           :multi-file?       true
           :accept-file-types [:file.type/pdf
                               :file.type/png
                               :file.type/jpg
                               :file.type/svg
                               :file.type/webp
                               :file.type/xls
                               :file.type/doc
                               :file.type/xlsx
                               :file.type/docx]
           :class             "w-full"
           :full-width?       true
           :show-clear?       true
           :value             nil
           :style-opts        {:container-height "auto"}
           :on-change         (fn [new-value]
                                (doseq [file (:files new-value)]
                                  (upload-event/start-upload! {:state*    state*
                                                               :target-id vault-id
                                                               :data      {}
                                                               :error!    (fn [resp]
                                                                            (js/console.log "Failed to upload file : " resp))
                                                               :success!  (fn [{:keys []}]
                                                                            )}
                                                              file)))}]
         [upload/indicators state*]
         [sortable-list/view
          {:items       files
           :get-key     :db/id
           :gap         8
           :on-reorder  (fn [{:keys [source-index destination-index]}]
                          (js/alert (str source-index " -> " destination-index)))
           :render-item (fn [{:keys [item index]}]
                          [:div
                           [file-item index item]])}]]))))

(defn view
  []
  [:div
   {:class "flex flex-col gap-2 border border-solid border-base-light-border-paler"}
   [:div
    {:class "flex flex-col gap-1 p-4 pb-0"}
    [text/h2
     (loc/tr :zap-vault-files)]
    [text/info-text
     (loc/tr :zap-vault-files-info)]]
   [:div
    {:class "flex flex-col gap-2 px-4 bg-complement-light items-start"}
    [:div
     {:class "flex flex-col gap-2 w-full max-w-[800px]"}
     [upload-and-progress]]]
   [delete-confirmation-modal]
   [edit-modal]])
